export const outputParamsToString = (input: AnyObject): string => {
  let data: string = '';

  Object.keys(input).forEach(function (k) {
    data += `${k}: ${input[k]} `;
  });

  return data;
};
